import { ActionButton } from '@eastcoal/common/components/Button/ActionButton'
import { useFeedback } from '@eastcoal/common/hooks/useFeedback'
import { pick } from '@eastcoal/common/utils/object'

import { useCrudFormStore } from '@eastcoal/formily/components/CrudForm/Store/hooks/useStore'
import { useCrudModalFormStore } from '@eastcoal/formily/components/CrudModalForm/Store/hooks/useStore'

export const CustomGroupFormSubmitButton = () => {
  const { message } = useFeedback()
  const { submit, form } = useCrudFormStore(state =>
    pick(state, ['submit', 'form'])
  )

  const { toggleModalOpen } = useCrudModalFormStore(state =>
    pick(state, ['toggleModalOpen'])
  )

  const handleSubmit = async () => {
    if (form.values.members.length) {
      await submit()
      toggleModalOpen()
    } else {
      message.error('会员不能为空！')
    }
  }
  return (
    <ActionButton type='primary' onClick={handleSubmit}>
      确定
    </ActionButton>
  )
}
